"use strict";
import { UniverseChainId } from "features/chains/types";
import { isInstantTokenBalanceUpdateEnabled } from "features/portfolio/portfolioUpdates/isInstantTokenBalanceUpdateEnabled";
import { refetchGQLQueriesViaBackendPollVariant } from "features/portfolio/portfolioUpdates/refetchGQLQueriesViaBackendPollVariantSaga";
import { refetchGQLQueriesViaOnchainOverrideVariant } from "features/portfolio/portfolioUpdates/refetchGQLQueriesViaOnchainOverrideVariantSaga";
const CHAINS_WITHOUT_GQL_BACKEND = /* @__PURE__ */ new Set([
  UniverseChainId.Mainnet,
  // BSC mainnet (56) — no subgraph yet
  UniverseChainId.Sepolia
  // BSC testnet (97) — no subgraph
]);
export function* refetchGQLQueries({
  transaction,
  apolloClient,
  activeAddress
}) {
  if (CHAINS_WITHOUT_GQL_BACKEND.has(transaction.chainId)) {
    return;
  }
  if (isInstantTokenBalanceUpdateEnabled()) {
    yield* refetchGQLQueriesViaOnchainOverrideVariant({ transaction, apolloClient, activeAddress });
  } else {
    yield* refetchGQLQueriesViaBackendPollVariant({ transaction, apolloClient, activeAddress });
  }
}
